module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.1a34218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/title-banner1-type3.png
// module id = huqk
// module chunks = 1